import HomeInfo from '../../components/home-screen-wrapper';

const Home: React.FC = () => {
	return <HomeInfo />;
};
export default Home;
